import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import IndividualProduct from "../components/individualProduct";
import ProductsBanner from "../components/ProductsBanner";
import WhatsAppFloatingButton from "../components/WhatsAppFloatingButton";
import { Helmet } from "react-helmet";
const BloodHemoglobin = () => {
  const title = "Dr. Chek D - Accurate Hemoglobin Meter for Fast Testing";
  const description =
    "Dr. Chek D Hemoglobin Meter ensures quick and precise hemoglobin testing. Ideal for home and professional use, featuring a portable and easy-to-use design.";

  const productData = {
    name: "Dr. Chek H",
    image:
      "/images/Dr Chek H_270x270.webp",
      "description":"The Dr. Chek H Reflectance Photometry based Hemoglobin Meter offers precise hemoglobin testing with reliable results. This portable Hb meter utilizes advanced reflectance photometry for accurate hemoglobin measurements. Ideal for point-of-care hemoglobin testing, it's designed for ease of use in diverse settings. Get rapid hemoglobin test results with this user-friendly device. Track Hb levels effectively for anemia monitoring and overall health assessment. The Dr. Chek H is a valuable tool for quick and accurate hemoglobin analysis, empowering both healthcare professionals and individuals seeking convenient hemoglobin monitoring. Explore the benefits of this reliable hemoglobin analyzer.",
    features: [
      "Large LCD Display",
      "Affordable Analyzer and Strips",
      "Proven Technology",
      "Calculated HCT",
      "Minimal Sample Volume",
      "High, Mediam, Low Indication",
    ],
    "brochure": {
      "pages": [
        "/images/Dr-Chek-H-Hemoglobin-Strips-Analyzer-brochure-1.jpg",
        "/images/Dr-Chek-H-Hemoglobin-Strips-Analyzer-brochure-2.jpg",
        
      ],
      "url": "/Dr.Chek-H-Hemoglobin-Strips-Analyzer-brochure.pdf"
    }
  };

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta
          name="keywords"
          content="Hemoglobin meter, Hemoglobin testing, Portable hemoglobin meter, Hemoglobin analyzer, Hb meter, Hemoglobin test kit, Point of care hemoglobin testing, Best hemoglobin meter for home use, Fast and accurate Hb testing, Digital hemoglobin analyzer, Blood hemoglobin measurement, FDA-approved Hb meter, Handheld hemoglobin tester, Buy hemoglobin meter online, Affordable hemoglobin test kit, Medical-grade hemoglobin meter, Quick hemoglobin level check, Hemoglobin monitoring device"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://yourwebsite.com" />
      </Helmet>
      <Header />
      <ProductsBanner
        title="Dr. Chek H"
        backgroundImage="/images/dr-chek-banner-001.png"
        backgrond="cover"
        height="400px"
      />
      <IndividualProduct product={productData} />
      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
};

export default BloodHemoglobin;
